<template>
	<div>
		<div class="left">
			<van-sidebar :active-key="active" @change="change">
			  <van-sidebar-item v-for="(item, index) in 15" :key="index" :title="'球磨' + item" />
			</van-sidebar>
		</div>
		<div class="right">
			<div>
				<van-cell-group v-for="(item, index) in list" v-if="index == active" :key="index" :title="item">
				  <van-cell v-for="(item, index) in list" :key="index" :title="item" clickable @click="edit(index)" value="123123123" />
				</van-cell-group>
			</div>
		</div>
		<van-dialog
		  use-slot
		  title="标题"
		  v-model="show"
		  show-cancel-button
		>
			<van-field placeholder="修改"></van-field>
		</van-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				show: false,
				list: ['胜灰石1', '胜灰石2']
			}
		},
		methods: {
			change(index) {
				this.active = index
			},
			edit(index) {
				this.show = true
			}
		}
	}
</script>

<style lang="less" scoped>
	.left {
		position: absolute;
		left: 0px;
		top: 0;
		bottom: 0;
		width: 86px;
		overflow: scroll;
		.van-sidebar-item {
			padding: 15px 10px;
		}
		.van-sidebar-item--select {
			border-color: #1989fa;
		}
	}
	.right {
		position: absolute;
		left: 90px;
		top: 0;
		bottom: 0;
		right: 0px;
		overflow: scroll;
	}
	
	
</style>
